<template lang="pug">
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-active="isModalScopeFabricatedHistoryVisible" vm-title='Fabrication History')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-tabs
        vm-tab(vm-label="Fabricated" vm-alignment="fixed")
          FabricatedTab(:fabricateds="fabricatedsHistory")
        vm-tab(vm-label="Shipped" vm-alignment="fixed")
          ShippedTab(:shippeds="shippedHistory")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')
import ShippedTab from '@/components/in-order/HistoryTabs/ShippedTab.vue'
import FabricatedTab from '@/components/in-order/HistoryTabs/FabricatedTab.vue'

export default {
  name: 'ModalScopeFabricatedHistory',
  components: {
    ShippedTab,
    FabricatedTab
  },
  props: {
    details: {
      type: Array
    }
  },
  data: () => ({
    columns: [
      'quantity',
      'fabricated_date'
    ]
  }),
  computed: {
    ...mapGetters([
      'isModalScopeFabricatedHistoryVisible',
      'fabricatedsHistory',
      'shippedHistory'
    ])
  },
  methods: {
    ...mapActions([
      'setModalScopeFabricatedHistoryVisible'
    ]),
    close () {
      this.setModalScopeFabricatedHistoryVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
</style>
